import React, { forwardRef, useState, useRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';

const CenterTypeSelect = forwardRef((props, ref) => {
  const { setVal } = props;
	const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

	const [isClicked, setIsClicked] = useState(false);
	const [defaultVal, setDefaultVal] = useState({ value: 'PT', text: t('myStoreSetting.centerType.pt') });

	const SelectRef = useRef();

	const options = [
		{ value: 'PT', text: t('myStoreSetting.centerType.pt') },
		{ value: 'groupTraining', text: t('myStoreSetting.centerType.groupTraining') },
		{ value: 'boutiqueFitness', text: t('myStoreSetting.centerType.boutiqueFitness') },
		{ value: 'normalFitness', text: t('myStoreSetting.centerType.normalFitness') },
		{ value: 'pilates', text: t('myStoreSetting.centerType.pilates') },
		{ value: 'yoga', text: t('myStoreSetting.centerType.yoga') },
		{ value: 'crossfit', text: t('myStoreSetting.centerType.crossfit') },
		{ value: 'basketball', text: t('myStoreSetting.centerType.basketball') },
		{ value: 'tennis', text: t('myStoreSetting.centerType.tennis') },
		{ value: 'baseball', text: t('myStoreSetting.centerType.baseball') },
		{ value: 'soccer', text: t('myStoreSetting.centerType.soccer') },
		{ value: 'spinning', text: t('myStoreSetting.centerType.spinning') },
		{ value: 'ballet', text: t('myStoreSetting.centerType.ballet') },
		{ value: 'boxing', text: t('myStoreSetting.centerType.boxing') },
		{ value: 'dance', text: t('myStoreSetting.centerType.dance') },
		{ value: 'golf', text: t('myStoreSetting.centerType.golf') },
		{ value: 'other', text: t('myStoreSetting.centerType.other') },
	];

	useImperativeHandle(ref, () => ({
		getValue: (val) => {
			return defaultVal.text;
		}
	}))

	function onClick() {
		if (isClicked) {
			SelectRef.current.style.border = `1px solid ${theme.line}`;
			SelectRef.current.style.height = `30px`;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			SelectRef.current.style.border = `1px solid ${theme.primary}`;
			SelectRef.current.style.height = `240px`;
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

	function optionalClick(index) {
		setDefaultVal(options[index]);
    setVal(options[index].text);
	}

	return (
		<TopLevelWrapper>
			<SelectBox
				ref={SelectRef}
				isClicked={isClicked}
				buttonPath={isClicked ? SelectOnPath : SelectOffPath}
				onClick={onClick}>
				{
					isClicked ?
						options.map((data, index) =>
							<OptionWrapper key={index} onClick={() => optionalClick(index)}>
								<Option>{data.text}</Option>
							</OptionWrapper>
						)
						:
						<OptionWrapper>
							<Option>
								{
									defaultVal.text
								}
							</Option>
						</OptionWrapper>
				}
			</SelectBox>
		</TopLevelWrapper>
	)
})

export default CenterTypeSelect;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	
	width: 238px;
	height: 30px;

	margin-top: 24px;
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	align-items: flex-start;

	width: 238px;
	height: 30px;

	border: 1px solid ${props => props.theme.line};
	border-radius: 8px;
	overflow: hidden;

  background: url(${props => props.buttonPath}) no-repeat 96% ${props => props.isClicked ? `3` : `55`}%;
	background-color: ${props => props.theme.subBackground};
  transition: all 0.3s ease-in-out;

	@media (hover: hover) {
		&:hover {
			cursor: pointer;
		}
	}

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		// background-color: #FF8B48;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	@media (hover: hover) {
		&:hover {
			cursor: pointer;
		}
	}
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
  
	color: ${props => props.theme.text};
	margin: 6px 0 6px 8px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;